import { DEFAULT_TOKENS_CLASS_NAME } from './const';
import { Type } from './enums';

export const getTokenClassNameByType = (type: Type) =>
  DEFAULT_TOKENS_CLASS_NAME[type];
